module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Translations")]), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.copyTranslate()
      }
    }
  }, [_vm._v(" kopraj iz")]), _vm._v(" "), _c('div', {
    class: _vm.isMobile() ? '' : 'flex-container',
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTranslation.key),
      expression: "newTranslation.key"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": 'Key',
      "name": "email"
    },
    domProps: {
      "value": (_vm.newTranslation.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTranslation, "key", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTranslation.valueFirst),
      expression: "newTranslation.valueFirst"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": 'value-' + _vm.languages[0].id,
      "name": "email"
    },
    domProps: {
      "value": (_vm.newTranslation.valueFirst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTranslation, "valueFirst", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTranslation.valueSecond),
      expression: "newTranslation.valueSecond"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": 'value-' + _vm.languages[1].id,
      "name": "email"
    },
    domProps: {
      "value": (_vm.newTranslation.valueSecond)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTranslation, "valueSecond", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.saveTranslation()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" Reset")])]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v("key")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "27%"
    }
  }, [_vm._v("value-" + _vm._s(_vm.languages[0].id))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("value-" + _vm._s(_vm.languages[1].id))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_edit')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.translations), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": 'key'
      }
    }, [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": 'value-' + _vm.languages[0].id
      }
    }, [_vm._v(_vm._s(item.valueFirst))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": 'value-' + _vm.languages[1].id
      }
    }, [_vm._v(_vm._s(item.valueSecond))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_edit')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editTranslation(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n              ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteTranslate(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n              ")])])])
  }), 0)])])])]), _vm._v(" "), _c('show-qr-code-dialog', {
    attrs: {
      "show": _vm.showQrCodeItem != null,
      "item": _vm.showQrCodeItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a8e5398!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Company/Translation.vue
// module id = 802
// module chunks = 0